import React, { useEffect, useRef, useState } from "react";
import { PRIMARY_COLOR } from "../../assets/style/colors";
import { call, bg, countryArr, back_icon, back_icon1, Logo } from "../../assets/img";
import { useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import countryData from "../../Services/CountryData.json";
import { Toast } from "../../Component/Toast";
import SubmitButton from "../../Component/SubmitButton";
import { MaskIcon } from "../MaskIcon";

const Forgot = () => {
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("+91");
  const [mobile, setMobile] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "", mobile: "" });
  const otpInputs = useRef([]);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [showOtp, setShowOtp] = useState(false);
  const [timer, setTimer] = useState(0); // countdown timer
  const timerRef = useRef(null); // to clear interval
  const [loading, setLoading] = useState(false);
  const [isLoading2, setIsloading2] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [country, setCountry] = useState("IN");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    countryData.find((c) => c.iso === "IN") || countryData[0],
  );
  const hiddenInputRef = useRef(null);
  const maxLength = selectedCountry?.maxLength;
  // // console.log("maxLength", maxLength);

  const validatePhone = (value, countryCode = "IN") => {
    const phoneNumber = parsePhoneNumberFromString(value, countryCode);
    return phoneNumber ? phoneNumber.isValid() : false;
  };

  useEffect(() => {
    const isMobileValid =
      validatePhone(mobile, country) && mobile.length >= maxLength;
    setIsFormValid(isMobileValid);
  }, [mobile, country, maxLength]);

  const handlePhoneChange = (value, data) => {
    setMobile(value.replace(/[-\s]/g, ""));
    if (data?.country?.dialCode) {
      setCountryCode(`+${data?.country?.dialCode}`);
    }
  };

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const handleSendOtp = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!validatePhone(mobile, country)) {
      newErrors.mobile = "Enter a valid phone number";
    } else if (mobile.length < maxLength) {
      newErrors.mobile = `Phone number must be at least ${maxLength} digits`;
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");
    const formdata = {
      mobile: cleanMobile,
      country_code: countryCode,
    };
    setLoading(true);
    try {
      const res = await post(URLS.FORGOTPASSWORD, formdata);
      // // console.log("res OTP sent", res);
      Toast(res.message || "OTP sent successfully!");
      if (res.status === "success") {
        setErrors({});
        setLoading(false);
        setShowOtp(true);
        setTimer(60);
        // alert(`OTP: ${res?.otp}`);
      }
    } catch (err) {
      // // console.log('forgot err', err);
      setErrors(newErrors);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setOtp(["", "", "", ""]);
     hiddenInputRef.current?.focus(); 
    setTimer(60);
    const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");
    const formdata = {
      mobile: cleanMobile,
      country_code: countryCode,
    };

    // // console.log("Form Data:", formdata);

    try {
      setLoading(true);
      const res = await post(URLS.FORGOTPASSWORD, formdata);
      // // console.log("forgot resent Response:", res);
      if (res?.status === "success") {
        Toast("OTP resent successfully!");
        // alert(`OTP: ${res?.otp}`);
      }
    } catch (err) {
      Toast("Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();

    const enteredOtp = otp.join("").trim();

    if (enteredOtp.length !== 4) {
      Toast("Please enter a valid 4-digit OTP");
      return;
    }

    const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");

    const formdata = {
      mobile: cleanMobile,
      country_code: countryCode,
      otp: enteredOtp,
    };
    setIsloading2(true);
    try {
      const res = await post(URLS.FORGOTVERIFYOTP, formdata);
      // // console.log("OTP verify response:", res);

      if (res.status === "success") {
        Toast(res.message || "OTP verified successfully!");
        setIsloading2(false);
        navigate("/create-password", {
          state: { id: res?.user_id, type: "forgot" },
        });
      } else {
        setIsloading2(false);
        Toast(res.message || "Invalid OTP, please try again.");
      }
    } catch (err) {
      setIsloading2(false);
      console.error("OTP verify error:", err);
      Toast("Something went wrong while verifying OTP");
    } finally {
      setIsloading2(false);
    }
  };

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        const next = document.getElementById(`otp-${index + 1}`);
        if (next) next.focus();
      }
    }
  };
  const handlePaste = (e) => {
    e.preventDefault();

    const pastedData = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 4);

    if (!pastedData) return;

    const newOtp = [...otp];

    pastedData.split("").forEach((digit, index) => {
      newOtp[index] = digit;
    });

    setOtp(newOtp);

    const lastIndex = Math.min(pastedData.length - 1, 3);
    otpInputs.current[lastIndex]?.focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault(); // prevent default deletion behavior
      const newOtp = [...otp];
      if (newOtp[index]) {
        // if current input has value, just clear it
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // if empty, move focus to previous
        document.getElementById(`otp-${index - 1}`).focus();
        const prevOtp = [...otp];
        prevOtp[index - 1] = "";
        setOtp(prevOtp);
      }
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, "");
    if (value.length <= maxLength) {
      setMobile(value);
      setErrors((prev) => ({ ...prev, mobile: "" }));
    }
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setCountryCode(country.code);
    setCountry(country.iso);
    setDropdownOpen(false);
  };

  return (
    <div style={{ backgroundColor: '#F0EDE6', minHeight: '100vh', overflow: 'hidden' }}>

      {/* ===== DESKTOP LAYOUT ===== */}
      <div className="d-none d-lg-flex" style={{ height: '100vh' }}>

        {/* LEFT */}
        {/* TOP - Image */}
        {/* LEFT */}
        <div style={{
          width: '50%',               // ← ADD THIS
          backgroundImage: "url('https://winner-ags.s3.us-east-1.amazonaws.com/Royal-agency/vasv4x+3.png')",
          backgroundColor: PRIMARY_COLOR,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: '100vh',            // ← CHANGE minHeight to height: 100vh
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <img src={Logo} alt="Logo" style={{ maxWidth: 400, width: '100%' }} />
        </div>

        {/* RIGHT */}
        <div style={{
          width: '50%',
          backgroundColor: '#F0EDE6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
        }}>
          <form style={{ width: '100%', maxWidth: 420 }}>
            <span style={{ display: 'flex', gap: 15, alignItems: 'center', cursor: 'pointer' }}
              onClick={() => navigate(-1)}>
              <img src={back_icon1} height={18} width={18} alt="back" />
              <h2 style={{ color: 'black', margin: 0 }} className="f3">Forgot password</h2>
            </span>

            <div style={{ marginTop: 35 }} className="form-group text-start">
              <label style={{ color: PRIMARY_COLOR }} className="form-label f3 mb-0">
                Mobile Number
              </label>
              <div className="login-input mt-1" style={{
                height: 50, background: '#F0EDE6', display: 'flex',
                alignItems: 'center', borderRadius: 8, position: 'relative',
              }}>
                <button type="button" onClick={() => setDropdownOpen(!dropdownOpen)}
                  style={{
                    backgroundColor: '#6E6E6E', border: `1px solid ${PRIMARY_COLOR}`,
                    color: '#ffffff', fontSize: 16, height: 50, display: 'flex',
                    alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                    borderRadius: '8px 0 0 8px', padding: '0px 10px', fontWeight: 600, gap: 6,
                  }}>
                  <img src={countryArr} style={{ width: 14, height: 8 }} alt="" />
                  {selectedCountry.code}
                </button>
                <input type="number" placeholder="Mobile Number" value={mobile}
                  onKeyDown={(e) => { if (['-', '+', '.', 'e', 'E'].includes(e.key)) e.preventDefault(); }}
                  onChange={handleMobileChange} className="placholdercolorchanges f2"
                  style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: 16, color: '#1B1B1B', padding: '0 10px', height: 50 }}
                />
                <MaskIcon src={call} alt="call" style={{ marginRight: 12, width: 17 }} />
                {dropdownOpen && (
                  <div style={{ position: 'absolute', top: 52, left: 0, right: 0, backgroundColor: '#ffffff', border: '1px solid rgb(0 71 67 / 40%)', borderRadius: 8, maxHeight: 200, overflowY: 'auto', zIndex: 1000 }}>
                    {countryData.map((c) => (
                      <div key={c.iso} onClick={() => handleCountrySelect(c)}
                        style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid rgb(0 71 67 / 40%)', backgroundColor: selectedCountry.iso === c.iso ? '#ffffff' : '#F0EDE6' }}>
                        {c.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>

            {!showOtp && (
              <SubmitButton onClick={handleSendOtp} title="Send OTP"
                style={{ marginTop: 40 }} disabled={!isFormValid || showOtp}
                isFormValid={!isFormValid} loading={loading} />
            )}

            {showOtp && (
              <>
                <p style={{ color: PRIMARY_COLOR, fontSize: 18, marginTop: 20 }} className="f3">
                  Enter the OTP
                </p>

                {/* Single hidden input — captures continuous typing on mobile */}
                <div
                  className="otp-container"
                  style={{ position: 'relative', cursor: 'text' }}
                  onClick={() => hiddenInputRef.current?.focus()}
                >
                  <input
                    ref={hiddenInputRef}
                    type="tel"
                    inputMode="numeric"
                    maxLength={4}
                    autoComplete="one-time-code"
                    pattern="[0-9]*"
                    value={otp.join('')}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, '').slice(0, 4);
                      setOtp(val.split('').concat(['', '', '', '']).slice(0, 4));
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const val = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 4);
                      setOtp(val.split('').concat(['', '', '', '']).slice(0, 4));
                    }}
                    style={{
                      position: 'absolute',
                      opacity: 0,
                      width: '100%',
                      height: '100%',
                      top: 0, left: 0,
                      zIndex: 10,
                      fontSize: 16,
                      border: 'none',
                      outline: 'none',
                      caretColor: 'transparent',
                      background: 'transparent',
                    }}
                  />
                  {/* Visual boxes — purely decorative, pointer-events off */}
                  {otp.map((digit, index) => (
                    <div
                      key={index}
                      className="otp-input"
                      style={{
                        pointerEvents: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {digit}
                    </div>
                  ))}
                </div>

                <p className="mt-2 f2 text-end" style={{ color: PRIMARY_COLOR }}>
                  {timer > 0 ? `Resend OTP in ${timer}s` : (
                    <span style={{ color: PRIMARY_COLOR, cursor: 'pointer' }} onClick={handleResend}>
                      Resend OTP
                    </span>
                  )}
                </p>
                <SubmitButton
                  onClick={handleConfirm}
                  title="Continue"
                  disabled={isLoading2}
                  isFormValid={otp.some((d) => d === '')}
                  loading={isLoading2}
                />
              </>
            )}
          </form>
        </div>
      </div>

      {/* ===== MOBILE LAYOUT ===== */}
      <div className="d-flex d-lg-none" style={{ flexDirection: 'column', minHeight: '100vh' }}>

        {/* TOP - Image */}
        <div style={{
          backgroundImage: "url('https://winner-ags.s3.us-east-1.amazonaws.com/Royal-agency/vasv4x+3.png')",
          backgroundColor: PRIMARY_COLOR,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '45vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          userSelect: 'none',
          WebkitUserSelect: 'none'
        }}>
          <img src={Logo} alt="Logo" style={{ maxWidth: 277, maxHeight: 277, width: '100%', position: 'relative', bottom: 12 }} />
        </div>
        {/* BOTTOM - Form */}
        <div style={{
          backgroundColor: '#F0EDE6',
          borderRadius: '60px 60px 0 0',
          marginTop: '-50px',
          zIndex: 1,
          position: 'relative',
          padding: '50px 24px 40px',
          flex: 1,
          userSelect: 'none',
          WebkitUserSelect: 'none'
        }}>
          <form style={{ maxWidth: 420, width: '100%', margin: '0 auto' }}>

            <span style={{ display: 'flex', gap: 15, alignItems: 'center', cursor: 'pointer', marginBottom: 10 }}
              onClick={() => navigate(-1)}>
              <img src={back_icon1} height={18} width={18} alt="back" />
              <h2 style={{ color: 'black', margin: 0, fontSize: 20 }} className="f3">
                Forgot password
              </h2>
            </span>

            <div style={{ marginTop: 25 }} className="form-group text-start">
              <label style={{ color: PRIMARY_COLOR }} className="form-label f3 mb-0">
                Mobile Number
              </label>
              <div className="login-input mt-1" style={{
                height: 50, background: '#F0EDE6', display: 'flex',
                alignItems: 'center', borderRadius: 8, position: 'relative',
              }}>
                <button type="button" onClick={() => setDropdownOpen(!dropdownOpen)}
                  style={{
                    backgroundColor: '#6E6E6E', border: `1px solid ${PRIMARY_COLOR}`,
                    color: '#ffffff', fontSize: 16, height: 50, display: 'flex',
                    alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                    borderRadius: '8px 0 0 8px', padding: '0px 10px', fontWeight: 600, gap: 6,
                  }}>
                  <img src={countryArr} style={{ width: 14, height: 8 }} alt="" />
                  {selectedCountry.code}
                </button>
                <input type="number" placeholder="Mobile Number" value={mobile}
                  onKeyDown={(e) => { if (['-', '+', '.', 'e', 'E'].includes(e.key)) e.preventDefault(); }}
                  onChange={handleMobileChange} className="placholdercolorchanges f2"
                  style={{ flex: 1, border: 'none', outline: 'none', backgroundColor: 'transparent', fontSize: 16, color: '#1B1B1B', padding: '0 10px', height: 50 }}
                />
                <MaskIcon src={call} alt="call" style={{ marginRight: 12, width: 17 }} />
                {dropdownOpen && (
                  <div style={{ position: 'absolute', top: 52, left: 0, right: 0, backgroundColor: '#ffffff', border: '1px solid rgb(0 71 67 / 40%)', borderRadius: 8, maxHeight: 200, overflowY: 'auto', zIndex: 1000 }}>
                    {countryData.map((c) => (
                      <div key={c.iso} onClick={() => handleCountrySelect(c)}
                        style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid rgb(0 71 67 / 40%)', backgroundColor: selectedCountry.iso === c.iso ? '#ffffff' : '#F0EDE6' }}>
                        {c.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {errors.mobile && <p className="err">{errors.mobile}</p>}
            </div>

            {!showOtp && (
              <SubmitButton onClick={handleSendOtp} title="Send OTP"
                style={{ marginTop: 40 }} disabled={!isFormValid || showOtp}
                isFormValid={!isFormValid} loading={loading} />
            )}

            {showOtp && (
              <>
                <p style={{ color: PRIMARY_COLOR, fontSize: 18, marginTop: 20 }} className="f3">
                  Enter the OTP
                </p>
                <div className="otp-container">
                  {otp.map((digit, index) => (
                    <input key={index} id={`otp-${index}`}
                      ref={(ref) => (otpInputs.current[index] = ref)}
                      type="tel" maxLength="1" value={digit}
                      onChange={(e) => handleChange(e.target.value, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className="otp-input" />
                  ))}
                </div>
                <p className="mt-2 f2 text-end" style={{ color: PRIMARY_COLOR }}>
                  {timer > 0 ? `Resend OTP in ${timer}s` : (
                    <span style={{ color: PRIMARY_COLOR, cursor: 'pointer' }} onClick={handleResend}>
                      Resend OTP
                    </span>
                  )}
                </p>
                <SubmitButton onClick={handleConfirm} title="Continue"
                  disabled={isLoading2} isFormValid={otp.some((d) => d === '')} loading={isLoading2} />
              </>
            )}
          </form>
        </div>
      </div>

    </div>
  );
};

export default Forgot;
